import type { SearchResultJobV5 } from '@seek/chalice-types';
import { JOB_DISPLAY_TYPE_QUERY_KEY } from '@seek/job-details-view';

import { addToQuery, removeFromQuery } from 'src/store/location';
import type { useDispatch } from 'src/store/react';
import { SELECTED_JOB_ID_SEARCH_QUERY_KEY } from 'src/store/results';
import { pushParams, removeParams } from 'src/utils/urlParams';

const keys = [SELECTED_JOB_ID_SEARCH_QUERY_KEY, JOB_DISPLAY_TYPE_QUERY_KEY];

export const persistJobUrl = ({
  job: { id, displayType },
  dispatch,
}: {
  job: Pick<SearchResultJobV5, 'id' | 'displayType'>;
  dispatch?: ReturnType<typeof useDispatch>;
}) => {
  const query = {
    [SELECTED_JOB_ID_SEARCH_QUERY_KEY]: String(id),
    [JOB_DISPLAY_TYPE_QUERY_KEY]: displayType,
  };
  pushParams(query);

  if (dispatch) {
    dispatch(addToQuery(query));
  }
};

export const removePersistedJobUrl = (
  dispatch?: ReturnType<typeof useDispatch>,
) => {
  removeParams(keys);
  if (dispatch) {
    dispatch(removeFromQuery(keys as [string]));
  }
};

export const compareJobIds = (
  currentJobId?: string,
  selectedJobId?: string,
) => {
  if (!currentJobId || !selectedJobId) {
    return false;
  }

  return currentJobId === selectedJobId;
};
